import React from 'react';

import { Box, Flex } from '@primer/components'

import { useProduct } from '../hooks/useProduct'

const circleStyle = {borderRadius: 50, padding: 5, background: 'white'}

const clients = [
  {src: '/brand-dit.png', name: 'Department for International Trade', style: circleStyle},
  {src: '/brand-giant.png', name: 'Giant', style: circleStyle},
  {src: '/brand-fool.png', name: 'Motley fool', style: circleStyle},
  {src: '/brand-liftinteractive.png', name: 'Lift Interactive', style: {}},
  {src: '/brand-lightmatter.png', name: 'Lightmatter', style: {}},
  {src: '/brand-mediainteractiva.png', name: 'Media Interactive', style: circleStyle},
  {src: '/brand-wemakeservices.png', name: 'We Make Services', style: {}},
  {src: '/brand-appsumo.png', name: 'Sumo', style: circleStyle},
]

export default function(props) {
  const productDetails = useProduct()

  return (
      <Box className="container-lg text-black" id="clients">
        <Box className="m-md-0 ml-2 mr-2 ml-md-4 mr-md-4 mt-4 text-white">
          <Box className="text-center f3 pb-4">Over <strong>3000 teams</strong> use {productDetails.name} to write better code, release faster, and save time.</Box>
          <Flex as="ul" className="list-style-none" justifyContent='space-between'>
            { clients.map((item, i) => (
              <li><img alt={item.name} title={item.name} src={item.src} style={{...item.style, maxHeight: '50px'}} className={i === clients.length -1 && 'hide-sm'} /></li>
            ))}
          </Flex>
        </Box>
      </Box>
  )
}
